import { useUserSession } from '@jusbrasil-web/shared-user-session'
import {
  SendMetrics,
  useDispatcher,
  UseDispatcherReturnType,
} from '@jusbrasil-web/shared-utils-events'
import { useCallback } from 'react'

type SendMetricsParameters = Parameters<SendMetrics>
type SendMetricsWrapperFunction = (
  name: SendMetricsParameters[0],
  properties?: SendMetricsParameters[2]
) => void

export function usePersistentAlertBannerDispatcher<T extends HTMLElement>(): Omit<
  UseDispatcherReturnType<T>,
  'sendMetrics'
> & {
  sendTopbarEvent: SendMetricsWrapperFunction
} {
  const user = useUserSession()
  const pid = `${user?.pid ?? ''}` || null

  const { sendMetrics, ...rest } = useDispatcher<T>()

  const [sendTopbarEvent] = ['Topbar'].map(
    (namespace): SendMetricsWrapperFunction =>
      // eslint-disable-next-line react-hooks/rules-of-hooks
      useCallback(
        (name, properties) => sendMetrics(`${namespace}.${name}`, pid, properties),
        [namespace]
      )
  )

  return {
    sendTopbarEvent,
    ...rest,
  }
}
